import request from '../../../utils/request';
const querystring = require('querystring')

//获取列表数据
export const fetchData = query => {
    var list = request({
        url: 'rootStation/selectPage.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

//启用-禁用
export const changeStatus = query => {
    var list = request({
        url: 'rootStation/changeStatus.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
//添加渠道信息
export const saveForm = query => {
    var list = request({
        url: 'rootStation/insert.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDelete = query => {
    var list = request({
        url: 'rootStation/delete.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const handDeleteMore = query => {
    var list = request({
        url: 'rootStation/deleteMore.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};
export const changeForm = query => {
    var list = request({
        url: 'rootStation/update.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};

export const fetchSelect = query => {
    var list = request({
        url: 'rootStation/getListFetch.do',
        method: 'post',
        data: querystring.stringify(query),
    });
    return list;
};




